import Link from 'next/link'

import styles from './nmo-instr-btn.module.scss'

const NMOInstrBtn = () => {
  return (
    <Link href="/nmo" prefetch={false}>
      <div className={styles.instruction}>
        <div className={styles.hint}>Инструкция по НМО</div>
        <div className={styles.question}>?</div>
      </div>
    </Link>
  )
}

export default NMOInstrBtn
